export class CycleCheckerDateReq{
    fromDate:Date;
    toDate:Date;
    createdAt?:Date;
}